
import React from 'react'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import CHero from '../Common/CHero'
import AboutWhy from './AboutWhy'
import AboutTeams from './AboutTeams'
import AboutContact from './AboutContact'

const About = () => {
  return (
    <>
    <Nav />
   
    <AboutWhy />
    <AboutTeams />
    <AboutContact  />
    <Footer />
    </>
  )
}

export default About